import type { AnalyticsListener } from '../types/listener.js';
import type { EventEnvelope } from '../types/envelope.js';

/**
 * No-op listener: implements the interface with no side effects.
 * Use when analytics is disabled or in tests.
 */
export function createNoopListener(): AnalyticsListener {
  return {
    init(_config: unknown): void {
      // no-op
    },
    track(_envelope: EventEnvelope): void {
      // no-op
    },
  };
}

/** Singleton no-op listener instance. */
export const noopListener: AnalyticsListener = createNoopListener();
